/**
 * Account & profile — the signed-in staff account's own settings, as a page.
 *
 * Staff used to reach their name, language and password only through a modal
 * off the user menu, while the Settings entry on the strip is org-level
 * (Roles & access). This gives them the same page owners have, minus Payouts.
 *
 * The audience is read from the role rather than hard-coded, so an owner who
 * lands here by URL still gets their own variant (with Payouts) instead of a
 * page that quietly drops one of their tabs.
 */
import { V2AdminNavbar } from "@/components/admin/v2/V2AdminNavbar";
import { AccountSettingsPanel } from "@/components/settings/AccountSettingsPanel";
import { useAuth } from "@/contexts/AuthContext";

export function AdminAccountPage() {
  const { isOwnerPortalOnly } = useAuth();
  return (
    <div
      className={
        isOwnerPortalOnly
          ? "min-h-screen bg-background"
          : "min-h-screen bg-[#F9FAFB] dark:bg-background"
      }
    >
      <V2AdminNavbar />
      <div
        className={`mx-auto px-4 sm:px-6 lg:px-8 pb-12 ${
          // Owners get the same top gap and 1920px cap as the rest of the
          // owner portal; staff keep the page's original shell.
          isOwnerPortalOnly
            ? "w-full max-w-[1920px] pt-6"
            : "max-w-screen-2xl pt-8"
        }`}
      >
        <AccountSettingsPanel
          audience={isOwnerPortalOnly ? "owner" : "staff"}
        />
      </div>
    </div>
  );
}

export default AdminAccountPage;
